import { isArabicScript } from './scriptConventions';

/**
 * The wordmark in the reader's script: «وفّقنا» for Arabic, "Wefaqna" for every
 * other language. The app's name was already "Wefaqna" in en/fr/de/es
 * (`common.appName`, the store listings, the landing screen) while the header
 * kept showing the Arabic artwork — one product wearing two names. Same gold
 * emblem in both, so the brand reads as one thing.
 */
export function brandLogoSrc(language) {
  // The same question brandName() asks, so the artwork and the name agree.
  return isArabicScript(language || 'ar') ? '/logo.png' : '/logo-en.png';
}
